@if (isForbidLoading || isDepositForbid) {
  <deposit-withdraw-forbid [isLoading]="isForbidLoading"></deposit-withdraw-forbid>
} @else if (isPaymentMethodUnavailable || !hasAvailableCardDepositCurrencies) {
  <div class="deposit-crypto-disabled" [appLoading]="paymentLoading">
    @if (!this.paymentLoading) {
      <i origin class="fi-information-circle"></i>
      <p class="title">Payment method unavailable</p>
      <p class="text">
        This payment method is temporarily unavailable. Please try again later or choose a different payment method to
        continue.
      </p>
    }
  </div>
} @else {
  <form [formGroup]="form" class="scroll-cont">
    <div class="section">
      <div class="cont">
        <div class="row">
          <!-- 選擇bonus -->
          <div class="item">
            <app-deposit-bonus-dropdown
              [currentCurrency]="currentCurrency"
              (bonusLoadingChange)="bonusLoading = $event"
              (activityNo)="activityNo = $event"
            ></app-deposit-bonus-dropdown>
          </div>
        </div>

        <div class="row flex-column">
          <!-- You will pay（法幣） -->
          <div class="item flex-row">
            <div class="item-inner">
              <div class="label">
                <span [class.error]="!!getPayError">You will pay</span>
              </div>
              <cs-input
                placeholder="Enter amount"
                [inputMode]="'decimal'"
                formControlName="payAmount"
                [hasError]="!!getPayError"
                [disabled]="!isAllLoaded()"
                [marginBottom]="'0'"
              ></cs-input>
            </div>
            <div class="item-inner">
              <div class="label"></div>
              <cs-select
                [(value)]="currentPayFiat"
                [options]="payFiatList"
                [disabled]="!isAllLoaded()"
                (valueChange)="onPayFiatChange()"
              ></cs-select>
            </div>
          </div>
          @if (getPayError) {
            <div class="msg error">{{ getPayError }}</div>
          }
        </div>

        <div class="row flex-column">
          <!-- You will get（Crypto，可輸入） -->
          <div class="item flex-row">
            <div class="item-inner">
              <div class="label">
                <span [class.error]="!!getPayError">You will get</span>
              </div>
              <cs-input
                type="number"
                placeholder="Enter amount"
                [inputMode]="'decimal'"
                [disabled]="!isAllLoaded()"
                formControlName="getAmount"
                [hasError]="!!getPayError"
                [marginBottom]="'0'"
              ></cs-input>
            </div>
            <div class="item-inner">
              <div class="label"></div>
              <cs-select
                [(value)]="currentCurrency"
                [options]="getFiatList"
                [disabled]="!isAllLoaded()"
                (valueChange)="onCurrencyChange()"
              ></cs-select>
            </div>
          </div>
        </div>

        <div class="row flex-column">
          <div class="item flex-col">
            <div class="label">
              <span>Payment provider</span>
            </div>
            <cs-select
              [width]="'100%'"
              [(value)]="currentPaymentProvider"
              [options]="paymentProviderList"
              [disabled]="!isAllLoaded() || paymentProviderList.length === 0"
              (valueChange)="onPaymentProviderChange()"
              [placeholder]="paymentProviderLoading ? 'Loading payment providers' : 'Select payment provider'"
            ></cs-select>
          </div>
        </div>

        @if (currentPaymentProviderKind === paymentProviderKind.InstaX) {
          <div class="row flex-column">
            <div class="item flex-col">
              <div class="label">
                <span>Payment method</span>
              </div>
              <cs-select
                [width]="'100%'"
                [(value)]="currentPaymentMethod"
                [options]="paymentMethodList"
                [disabled]="!isAllLoaded() || paymentMethodList.length === 0"
                (valueChange)="onPaymentMethodChange()"
                [placeholder]="'Select payment method'"
              ></cs-select>
            </div>
          </div>
        }

        <div class="row">
          <div class="item">
            @if (currentPaymentProviderKind === paymentProviderKind.Rillpay) {
              <!-- Rillpay 維持舊版可用支付方式圖示，InstaX 則依需求隱藏。 -->
              <div class="bottom">
                @if (localStorageService.theme == 'sun') {
                  <img
                    src="assets/images/deposit-crypto/bottom/payment-light.png"
                    alt="Visa MasterCard ApplePay GooglePay"
                  />
                } @else {
                  <img
                    src="assets/images/deposit-crypto/bottom/payment-dark.png"
                    alt="Visa MasterCard ApplePay GooglePay"
                  />
                }
              </div>
            }
            <cs-button
              label="Deposit Now"
              color="accent"
              size="large"
              [loading]="!isAllLoaded()"
              [disabled]="!canSubmit()"
              (buttonClick)="submit()"
            ></cs-button>
          </div>
        </div>
      </div>

      <div class="note">
        <span>Already have crypto?</span>
        <cs-button
          (buttonClick)="walletService.jump('deposit', 'transfer')"
          color="secondary"
          width="auto"
          size="small"
          label="Transfer to crypto address"
        ></cs-button>
      </div>
    </div>
  </form>
}
